"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./modules/sentry");
// With .autoProvideJquery() in webpack.config.js we'll need to declare jQuery globally here,
// otherwise it'll either fall flat on JS that is kept outside webpack (e.g. stuff inlined in templates) or for stuff inside webpack,
// as, for example, the structure for the old style of the complete order forms
// Also, since jQuery isn't typed, we'll ignore that line (just that one!), to satisfy the linting.
const jquery_1 = __importDefault(require("jquery"));
Object.assign(window, { $: jquery_1.default, jQuery: jquery_1.default });
// TODO: Refactor this legacy thing at some point.
// Dependencies for legacy code
require("jquery.cookie");
require("jquery-unveil");
require("tooltipster");
// Legacy code
require("./modules/legacy/_main");
require("./modules/legacy/prg");
require("./modules/legacy/_extendFancybox");
require("./modules/legacy/cookie-notice");
require("./modules/legacy/unveilBackground");
require("./modules/legacy/select2");
require("./modules/legacy/print");
require("./modules/legacy/privacy");
require("./modules/legacy/publications");
require("./modules/legacy/readmore");
require("./modules/legacy/registration");
require("./modules/legacy/smoothScrolling");
require("./modules/legacy/teaser");
require("./modules/legacy/topCartSearch");
require("./modules/legacy/toTopLink");
require("./modules/legacy/content/marginal");
require("./modules/legacy/content/popupLinks");
require("./modules/legacy/forms/async");
require("./modules/legacy/forms/buttons");
require("./modules/legacy/forms/datamintsFeuser");
require("./modules/legacy/forms/powermail");
require("./modules/legacy/forms/select");
require("./modules/legacy/panels/academyEvents");
require("./modules/legacy/panels/filter");
require("./modules/legacy/attachThrobber");
require("./modules/legacy/activityIndicator");
require("./modules/legacy/blockquotes");
require("./modules/legacy/complete");
require("./modules/legacy/content");
require("./modules/legacy/complete/tooltip");
require("./modules/legacy/content/datepicker");
require("./modules/legacy/content/lightbox");
require("./modules/legacy/download");
require("./modules/legacy/downloads");
require("./modules/legacy/filter");
require("./modules/legacy/foldout");
require("./modules/legacy/forms");
require("./modules/legacy/images");
require("./modules/legacy/images/lightbox");
require("./modules/legacy/login");
require("./modules/legacy/onClickEvents");
require("./modules/legacy/panels");
require("./modules/legacy/seminars/seminars");
require("./modules/legacy/cart");
require("../scss/App.scss");
// Everything down here is freshly made and will run through TypeScript, and is therefore be typed all the way!
// New stuff shall be added below
require("./modules/global/equalHeight");
require("./modules/global/searchbar");
require("./modules/global/navigation");
require("./modules/global/footer");
require("./modules/cards");
require("./modules/global/modal");
require("./modules/global/frontendlogin");
require("./modules/global/consentVerification");
require("./modules/global/lightbox");
require("./modules/global/metrics");
require("./modules/global/downloads");
require("./modules/global/contactHide");
require("./modules/global/eventemitter");
require("./modules/product-table");
require("./modules/global/image-embed");
require("./modules/checkbox-modal");
require("./modules/global/dynamic-iframes");
require("./modules/serviceplattform-logout");
// Backports from Relaunch
require("./search-bar");
require("./login-box");
